import StatisticsCard from "./StatisticsCard";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { FaUserAlt, FaUsers } from "react-icons/fa";

export default function StatisticsList({ data }) {
  return (
    <div className="d-flex flex-wrap">
      <div className="col-6 col-sm-4 my-1">
        <StatisticsCard
          lightColor={"#3362a5"}
          darkColor={"#224982"}
          text={"تعداد عملیاتهای مانیتور شده"}
          statistic={data?.countOperation}
          mainTextColor={"white"}
          Icon={
            <HiOutlineDocumentReport
              color="navy"
              style={{ width: 25, height: 25 }}
            />
          }
        />
      </div>
      <div className="col-6 col-sm-4 my-1">
        <StatisticsCard
          lightColor={"#fbb867"}
          darkColor={"#ffae4b"}
          text={"تعداد کل پرسنل ارزیابی شده"}
          statistic={data?.assessedPersonnel}
          mainTextColor={"white"}
          Icon={<FaUserAlt color="navy" style={{ width: 25, height: 25 }} />}
        />
      </div>
      <div className="col-6 col-sm-4 my-1">
        <StatisticsCard
          lightColor={"#69cd96"}
          darkColor={"#4f996e"}
          // text={"تعداد کل پرسنل فعال"}
          text={<div>تعداد کل پرسنل فعال</div>}
          statistic={data?.activePersonnel}
          mainTextColor={"white"}
          Icon={<FaUsers color="navy" style={{ width: 25, height: 25 }} />}
        />
      </div>
      <div className="col-6 col-sm-4 my-1">
        <StatisticsCard
          text={
            <div>
              شاخص عملکرد
              <div className="fw-lighter mt-1" style={{ fontSize: 10 }}>
                ساعات‌حضور/خروجی‌مفید
              </div>
            </div>
          }
          statistic={data?.Operation}
          mainTextColor={"navy"}
          Icon={
            <HiOutlineDocumentReport
              style={{ width: 25, height: 25 }}
              color="white"
            />
          }
        />
      </div>
      <div className="col-6 col-sm-4 my-1">
        <StatisticsCard
          text={
            <div>
              &nbsp; شاخص میانگین خروجی مفید روزانه
              <span style={{ fontSize: 10 }}> (نفرساعت)</span>
            </div>
          }
          statistic={Math.floor(data?.UsefulDailyOutput)}
          mainTextColor={"navy"}
          Icon={
            <HiOutlineDocumentReport
              style={{ width: 25, height: 25 }}
              color="white"
            />
          }
        />
      </div>
      <div className="col-6 col-sm-4 my-1">
        <StatisticsCard
          text={
            <div>
              &nbsp; شاخص میانگین حضور
              <span style={{ fontSize: 10 }}> (ساعت)</span>
            </div>
          }
          statistic={data?.averageAttendance}
          mainTextColor={"navy"}
          Icon={
            <HiOutlineDocumentReport
              style={{ width: 25, height: 25 }}
              color="white"
            />
          }
        />
      </div>
    </div>
  );
}
